import axios from 'axios';

class AddressService {
    constructor(http, endpoint) {
        this.http = http;
        this.endpoint = endpoint;
    }
    async lookup(postcode) {
        return this.http.get(`${this.endpoint}/api/address?postcode=${postcode}`)
            .then(r => r.data);
    }
}

export const addressService = new AddressService(axios, `http://localhost:3000`);